import React, { FC } from "react";
import cx from "classnames";
import { useIsMobile } from "@pepdirect/helpers/useIsMobile";
import st from "./index.module.scss";

export const FocusPagePhotography: FC = () => {
  const isMobile = useIsMobile();

  return (
    <div className={st.container}>
      <div className={st.content}>
        {isMobile ? (
          <>
            <div
              className={cx(st.largeImage)}
              style={{
                background: `url("https://www.datocms-assets.com/74813/1705957347-extra-hero.png") center / cover no-repeat`,
              }}
            />
            <div
              className={st.smallImage}
              style={{
                background: `url("https://www.datocms-assets.com/74813/1705957364-teaser-still-jan-17-2024.png") center / cover no-repeat`,
              }}
            />
            <div
              className={cx(st.largeImage)}
              style={{
                background: `url("https://www.datocms-assets.com/74813/1705957358-hero-still-v03.png") center / cover no-repeat`,
              }}
            />
            <div
              className={st.smallImage}
              style={{
                background: `url("https://www.datocms-assets.com/74813/1705957353-extra-play.png") center / cover no-repeat`,
              }}
            />
          </>
        ) : (
          <>
            <div className={st.row}>
              <div
                className={cx(st.largeImage)}
                style={{
                  background: `url("https://www.datocms-assets.com/74813/1705957347-extra-hero.png") center / cover no-repeat`,
                }}
              />
              <div
                className={st.smallImage}
                style={{
                  background: `url("https://www.datocms-assets.com/74813/1705957364-teaser-still-jan-17-2024.png") center / cover no-repeat`,
                }}
              />
            </div>
            <div className={st.row}>
              <div
                className={st.smallImage}
                style={{
                  background: `url("https://www.datocms-assets.com/74813/1705957358-hero-still-v03.png") center / cover no-repeat`,
                }}
              />
              <div
                className={cx(st.largeImage)}
                style={{
                  background: `url("https://www.datocms-assets.com/74813/1705957353-extra-play.png") center / cover no-repeat`,
                }}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
